import React, { useState } from "react";
import {
	Form,Dropdown
} from 'formsy-semantic-ui-react';
import {Message } from 'semantic-ui-react';
import validationRule from "../../../../validation";
import "../../../Modal/dialog.css";
// import CheckboxTree from "./PrevilegesTree.js";

import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import CustomErrorField from "../../../Form/CustomErrorField";
import {
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdChevronRight,
  MdKeyboardArrowDown,
  MdAddBox,
  MdIndeterminateCheckBox,
  MdFolder,
  MdFolderOpen,
  MdInsertDriveFile
} from "react-icons/md";


validationRule.isRequired();  
validationRule.minCustomLength(8); 

const DialogBoxAddEdit = ({ obj, modalClose, onValidSubmit,  currentChecked, currentExpanded, setCurrentCheck, setCurrentExpand,legacybuttons,setSubUserLocation, filteredModuleList, isPLG }) => {
	let show = obj.modalstatusAddEdit;
	let title = obj.modaltitle;
	let modalErrorMsg = obj.modalErrorMsg;
	let modalErrorMsgLegacy = obj.modalErrorMsgLegacy;
	let invalidEmailMsg = obj.invalidEmailMsg;
	let invalidEmail = obj.invalidEmail;
	let modaldata = obj.modaldata;
	let modalFormLoader = obj.modalFormLoader;
	let selectedOption = obj.selectedOptions;
	let accessModuleList = filteredModuleList && filteredModuleList.length > 0 ? filteredModuleList : obj.accessModuleList;
	// const [check,setCheck] = useState(checked)
	// const [expand,setExpand] = useState(expanded)
	// alert(checked)
	// let options = [];
	// optionsPre.forEach((item2, index2) => {
	// 	Object.keys(item2).forEach(function (key) {
	// 		options.push({ "value": key, "text": item2[key] });
	// 	});
	// });
	const errorLabel = <div className="red"/>
	let passwordField = '';
	if (modaldata.id) {
		passwordField = <Form.Input fluid autoComplete="off" type='password' name="password" value='' placeholder='' validations={{matchRegexp:/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/}}  validationErrors={{matchRegexp: "Password needs to be at least 8 characters, include an uppercase and lowercase letter, a number, and a symbol." }} errorLabel={errorLabel} style={{borderBottom:'1px solid #ccc',marginTop:'5px'}}/>
		// passwordField = <Form.Input fluid autoComplete="off" type='password' name="password" value='' placeholder='' validations={{matchRegexp:/^(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/}} validationErrors={{matchRegexp: "Password must contain a letter,number,special char and min 8 char length." }} errorLabel={errorLabel}/>
	} else {
		// passwordField = <Form.Input fluid autoComplete="off" type='password' name="password" value='' placeholder='' validations='isRequired,minCustomLength' validationErrors={{ isRequired: 'This field is required.', minCustomLength: "Please enter at least 8 characters." }} errorLabel={errorLabel} /
		passwordField = <Form.Input fluid autoComplete="off" type='password' name="password" value='' placeholder='' validations={{matchRegexp:/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,isRequired:"isRequired"}} validationErrors={{ isRequired: 'This field is required.',matchRegexp: "Password needs to be at least 8 characters, include an uppercase and lowercase letter, a number, and a symbol." }} errorLabel={errorLabel} style={{borderBottom:'1px solid #ccc',marginTop:'5px'}}/>
	}
	const renderTree = () =>{
		const icons = {
			check: <MdCheckBox className="rct-icon rct-icon-check" />,
			uncheck: <MdCheckBoxOutlineBlank className="rct-icon rct-icon-uncheck" />,	
			halfCheck: (
			  <MdIndeterminateCheckBox className="rct-icon rct-icon-half-check" />
			),
			expandClose: (
			  <MdChevronRight className="rct-icon rct-icon-expand-close" />
			),
			expandOpen: (
			  <MdKeyboardArrowDown className="rct-icon rct-icon-expand-open" />
			),
			expandAll: <MdAddBox className="rct-icon rct-icon-expand-all" />,
			collapseAll: (
			  <MdIndeterminateCheckBox className="rct-icon rct-icon-collapse-all" />
			),
			parentClose: <MdFolder className="rct-icon rct-icon-parent-close" />,
			parentOpen: <MdFolderOpen className="rct-icon rct-icon-parent-open" />,
			leaf: <MdInsertDriveFile className="" />
		  };
		  console.log(this);
		  return (
			<CheckboxTree
			  nodes={accessModuleList}
			  checked={currentChecked}
			  expanded={currentExpanded}
			  onCheck={checked => onCheck(checked)}
			  onExpand={checked => onExpand(checked)}
			  icons={icons}
			/>
		  );
	}

	const onCheck = (checked)=>{
		setCurrentCheck(checked)
	}

	const onExpand = (checked)=>{
		console.log(checked)
		setCurrentExpand(checked)
	}

	const modalCloseHere = (t,fid) =>{
		// setCurrentCheck([]);
		// setCurrentExpand([])
		modalClose(false, 'formManageUser')
	}

	return (
		<React.Fragment>
			<div
				className={show ? "modal fade show" : "modal fade"}
				data-backdrop="static"
				tabIndex="-1"
				role="dialog"
				aria-labelledby="staticBackdrop"
				aria-hidden="true"
				style={{ display: show ? "block" : "none" }}
			>
				<div className="modal-dialog modal-dialog-centered" role="document">
					<div className="modal-content">
						<button
							type="button"
							className="close linear-gradient"
							data-dismiss="modal"
							aria-label="Close"
							onClick={() => modalCloseHere(false, 'formManageUser')}
						>
							X
						</button>
						<div className="modal-header">
							<h5 className="modal-title">{title}</h5>
						</div>
						<Form  noValidate autoComplete="off" id="formManageUser" onValidSubmit={onValidSubmit}>
						    {modalFormLoader && <div className="ui loading form"></div>}
							<div className="modal-body">
								<div className="kt-portlet__body py-0">
									<div className="kt-section kt-section--first">
									<Message color='red' style={{ display: invalidEmail ? "block" : "none" }}>{invalidEmailMsg}</Message>	
									<Message color='red' style={{ display: modalErrorMsg ? "block" : "none" }}>This email id is registered and is being used by different companies.</Message>
									<Message color='red' style={{ display: modalErrorMsgLegacy ? "block" : "none" }}>This email-id is already exists in Legacy notification members. To create sub account for this email-id please delete from Legacy member notification list.</Message>
										<div className="kt-section__body">
											<div className="form-group row">
												<label className="col-lg-4 col-form-label">Full Name :</label>
												<div className="col-lg-8">
													<Form.Input fluid autoComplete="off" name="name" value={modaldata.name} placeholder=''
														validations='isRequired' validationErrors={{ isRequired: 'This field is required.' }} errorLabel={errorLabel} style={{borderBottom:'1px solid #ccc',marginTop:'5px'}}/>
												</div>
											</div>
											<div className="form-group row">
												<label className="col-lg-4 col-form-label">Email  :</label>
												<div className="col-lg-8">
													<Form.Input fluid autoComplete="off" name="email" value={modaldata.email} placeholder=''
														validations='isEmail,isRequired' validationErrors={{ isEmail: 'Please enter a valid email address.', isRequired: 'This field is required.'}} errorLabel={errorLabel} style={{borderBottom:'1px solid #ccc',marginTop:'5px'}}/>
												</div>
											</div>
											<div className="form-group row">
												<label className="col-lg-4 col-form-label">Password  :</label>
												<div className="col-lg-8">
													{passwordField}
												</div>
											</div>


											{!isPLG && (
											<div className="form-group row">
												<label className="col-lg-4 col-form-label">Access Modules  :</label>
												<div className="col-lg-8 col-form-label" style={{overflowY:'auto',maxHeight:'200px',marginTop:'8px',paddingLeft: '0px'}}>
												{renderTree()}
												</div>
											</div>
											)}
											{!isPLG && currentChecked.length == 0  &&  (
											<div className="form-group row accessModule">
												<label  className={currentChecked.length==0 ? 'col-lg-4 form-control is-invalid':'col-lg-4 col-form-label form-control'} style={{visibility:'hidden'}}>  </label>


													<CustomErrorField
														message='Please select atleast one module.'
														className="error invalid-feedback col-lg-8"
													/>

											</div>
											)}
											
										</div>
									</div></div></div>
							<div className="kt-portlet__foot">
								<div className="kt-form__actions">
									<div className="row">
										<div className="col-lg-12 d-flex justify-content-end">
											<Form.Input name="subaccount_id" type="hidden" value={modaldata.id} />
											<button type="reset" onClick={() => modalCloseHere(false, 'formManageUser')} className="btn linear-gradient-cancel yr-cancelbtn mg-r"><span> Cancel </span></button>
											<button type="submit" className="btn linear-gradient yr-submitbtn">Submit</button>
											

										</div>
									</div>
								</div>
							</div>
						</Form>

					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default DialogBoxAddEdit;
